import { FormControl, FormArray, FormBuilder, Validators } from '@angular/forms';
import { TableProfile } from 'src/app/services/API.service';
import { ColumnForm } from './column-form';

export class TableForm {
    Columns: FormArray = new FormArray([]);
    PageSizeOptions = new FormControl();

    constructor(table: TableProfile, private fb: FormBuilder) {

        if (table) {
            this.PageSizeOptions.setValue(table.PageSizeOptions);

            table.Columns.forEach(n => {
                this.Columns.push(this.fb.group(new ColumnForm(n)));
            });
        }
        
        this.PageSizeOptions.setValidators([Validators.required]);
    }
}